'use strict';

var $ = require('jquery');
var EgressIntent = require('egress-intent').default;
var magnific = require('magnific-popup');

var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

var picturefill = require('picturefill');

function init() {
	if (!document.body.classList.contains('_landing'))
		return;

	initializeButton();
	initializeSocMed();
	initializeModal();
}

function initializeButton() {
	var landingBtn = document.querySelectorAll('.landingMasthead .btn, .scrollToLink');
	if (landingBtn === null || landingBtn.length === 0) {
		return;
	}

	
	function scrollToLinkedEl(event) {
		event.preventDefault();

		var linkedId = $(this).attr('href').match(/#(.*)/)[0];
		var $linkedEl = $(linkedId);

		var current = document.documentElement.scrollTop;
		var dest = $linkedEl.offset().top - 20;
		var duration = Math.max(200, (dest - current) / 2);

		$('html, body').animate({
			scrollTop: dest
		}, {
			duration: duration,
			easing: 'easeInOutSine'
		});
	}

	$(landingBtn).on('click', scrollToLinkedEl);
}

function initializeSocMed() {
	$(document).on('click', '.shareBtn--facebook', function() {
		if (FB) {
			FB.ui({
				method: 'share',
				hashtag: '#BooksForAfrica',
			}, function(response) {});
			myAnalytics.trackEvent('Social', 'Share', 'Facebook');
		}
	});
}

function initializeModal() {
	var modalSrc = document.getElementById('ouibounceModal');
	if (!modalSrc)
		return;

	var modal = new EgressIntent({
		delay: 200,
		directions: 'top',
		callback: function() {
			$.magnificPopup.open({
				items: {
					src: '#ouibounceModal',
					type: 'inline'
				}
			});
		}
	});

	$(document).on('ajaxComplete', function(event) {
		if (modal) {
			modal.disable({ cookieExpire: 1 });
			if (window.twttr) {
				window.twttr.widgets.load();
			}
		}
	});

	$('form').on('change', function() {
		if (modal) {
			modal.disable({ cookieExpire: 1 });
		}
	})
}

module.exports = {
	init: init
}
